/**
 * lazy-load.js
 *
 * @package Wordpress/sww
 * @since 1.1.4
 * @version 1.0.0
 */

'use strict';

/* global jQuery */
/* global swwapp */
/* global i */
jQuery(function ($) {
  $(document).ready(function () {
    /**
     * Lazy Load Object
     *
     * @property   array lazyLoadContainer All determined Lazy Load Container
     * @property   array lazyLoadImages    All determined Images
     * @property   array displayPostCards  All Display-Post-Widget Container
     * @method     void  getDisplayPostCards()
     * @method     void  collectLazyLaodImages()
     * @method     void  changeImage()
     * @method     void  loader()
     * @method     void  resizeHandler()
     * @method     void  init()
     */
    swwapp.lazyLoad = {
      /**
       * Property for the Lazy Load Container
       *
       * @since 1.0.0
       * @var  array lazyLoadContainer All determined Lazy Load Container
       */
      lazyLoadContainer: [],
      /**
       * Property for the determined Images
       *
       * @since   1.0.0
       * @var     array lazyLoadImages All determined Images
       */
      lazyLoadImages: '',
      /**
       * Property for the determined Diplay-Post-Widget Cards
       *
       * @since   1.0.0
       * @var     array adisplayPostCards All Display-Post-Widget Container
       */
      displayPostCards: '',
      /**
       * Method to get all Display-Post-Widget Cards
       *
       * @since   1.0.0
       * @var     array tmpCards All Display-Post-Widget Cards
       * @return  void
       */
      getDisplayPostCards: function getDisplayPostCards() {
        var tmpCards = $('.main-inner-wrap').find('.sww-widget-display-post');
        if (tmpCards.length > 0) {
          swwapp.lazyLoad.displayPostCards = tmpCards;
        } else {
          swwapp.lazyLoad.displayPostCards = 'none';
        }
        this.collectLazyLoadImages();
        return;
      },
      /**
       * Method to collect all lazy-load determined images
       *
       * @since   1.0.0
       * @var     array tmpImages   All determined Images
       * @return  void
       */
      collectLazyLoadImages: function collectLazyLoadImages() {
        if (this.displayPostCards != 'none') {
          var tmpImages = $(this.displayPostCards).find('img');
          if (tmpImages.length != 0) {
            this.lazyLoadImages = tmpImages;
          } else {
            this.lazyLoadImages = 'none';
          }
        }
        this.changeImage();
        return;
      },
      /**
       * Method to change the images against the loader-GIF
       *
       * @since   1.0.0
       * @var     array    tmpContainer   Array with objects to describe the lazy-load image
       * @var     integer  imageCount     The count of all lazyLoadImages
       * @var     url      string         The URL of the page
       * @var     loader   string         The loader-Element
       * @return  void
       */
      changeImage: function changeImage() {
        if (this.lazyLoadImages.length !== 'none') {
          var tmpContainer = [];
          var imagecount = this.lazyLoadImages.length;
          for (var i = 0; i < imagecount; i++) {
            tmpContainer[i] = {
              clientHeight: $(this.lazyLoadImages[i])[0].clientHeight,
              clientWidth: $(this.lazyLoadImages[i])[0].clientWidth,
              source: $(this.lazyLoadImages[i]).attr('src'),
              parentElement: $(this.lazyLoadImages[i]).parent(),
              loaded: false,
              altText: $(this.lazyLoadImages[i]).attr('alt')
            };
            this.lazyLoadContainer.push(tmpContainer[i]);
            var url = location.origin;
            if (url === 'http://localhost') {
              url = 'http://localhost/432761.imhof-digital.de';
            }
            var loader = '<div class="lazy-load container container-' + i + '"><img src="' + url + '/wp-content/themes/sww/assets/img/loader.gif" alt="Loader"></div>';
            $(tmpContainer[i].parentElement).find('img').replaceWith(loader);
            $('.lazy-load.container-' + i).css({
              height: tmpContainer[i].clientHeight + 'px',
              backgroundColor: 'white',
              position: 'relative'
            }).find('img').css({
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate( -50%, -50% )'
            });
          }
        }
        this.loader();
        this.resizeHandler();
        return;
      },
      /**
       * Method to load the Original Images on scrolling
       *
       * @since   1.0.0
       * @var     integer  scrollHeight   The scrolled window-position
       * @var     integer  viewHeight     The inner Height of the window
       * @var     integer  containerCount The count of the lazyLoadContainer
       * @return  void
       */
      loader: function loader() {
        if (this.lazyLoadContainer.length != 0) {
          $(window).on('scroll', function () {
            var scrollHeight = $(window)[0].pageYOffset;
            var viewHeight = $(window)[0].innerHeight;
            var containerCount = swwapp.lazyLoad.lazyLoadContainer.length;
            for (var i = 0; i < containerCount; i++) {
              if ($(swwapp.lazyLoad.lazyLoadContainer[i])[0].parentElement[0].offsetTop < viewHeight * 1.3 + scrollHeight && swwapp.lazyLoad.lazyLoadContainer[i].loaded === false) {
                var image = '<img width="100%" src="' + swwapp.lazyLoad.lazyLoadContainer[i].source + '" alt="' + swwapp.lazyLoad.lazyLoadContainer[i].altText + '">';
                swwapp.lazyLoad.lazyLoadContainer[i].parentElement.find('.lazy-load.container img').replaceWith(image);
                swwapp.lazyLoad.lazyLoadContainer[i].loaded = true;
              }
            }
          });
        }
      },
      /**
       * Method to resize the lazyLoadContainer
       *
       * @since   1.0.0
       * @var     integer  containerCount The count of the lazyLoadContainer
       * @var     object   container      The determined lazyLoadContainer
       * @var     object   image          The image in the container
       * @return  void
       */
      resizeHandler: function resizeHandler() {
        $(window).on('resize', function () {
          var containerCount = swwapp.lazyLoad.lazyLoadContainer.length;
          for (var i = 0; i < containerCount; i++) {
            if (swwapp.lazyLoad.lazyLoadContainer[i].loaded === true) {
              var container = $(swwapp.lazyLoad.lazyLoadContainer[i].parentElement).find('.lazy-load.container');
              var image = $(container).find('img');
              $(container).css('height', $(image)[0].clientHeight + 'px');
            }
          }
        });
        return;
      },
      /**
       * Method to initiate the lazy load
       *
       * @since   1.0.0
       * @uses    this.getDisplayPostCards for initiation
       * @return  void
       */
      init: function init() {
        swwapp.lazyLoad.getDisplayPostCards();
        return;
      }
    };
    // swwapp.lazyLoad.init();
  });
});